<template>
  <div class="animated fadeIn">
    <h5 v-if="footer.approved_by">
      Approved by: {{ footer.approved_by }}
    </h5>
    <h5 v-if="footer.bdl">
      BDL: {{ footer.bdl }}
    </h5>
    <p v-for="(note, index) in footer.notes" :key="index" class="mb-1">{{ note }}</p>
  </div>
</template>

<script>
export default {
  name: "SubmissionReportFooter",
  props: {
    footer: {
      type: Object,
      default: () => {
        return {}
      }
    }
  }
}

</script>
